import { FormControlLabel, styled, Switch, SwitchProps } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

const StyledSwitch = styled(Switch)(({ theme }) => ({
    width: 50,
    height: 30,
    padding: 0,
    margin: 4,

    "& .MuiSwitch-switchBase": {
        padding: 2,
        transitionDuration: "300ms",

        "&.Mui-checked": {
            transform: "translateX(20px)",
            color: "#fff",

            "& + .MuiSwitch-track": {
                backgroundColor: "#1E88FF", // blue like your image
                opacity: 1,
                border: 0,
            },
        },
    },

    "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 26,
        height: 26,
        backgroundColor: "#fff",
    },

    "& .MuiSwitch-track": {
        borderRadius: 34 / 2,
        backgroundColor: "#C7D7FF",
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
            duration: 300,
        }),
    },
}));

interface SystemSwitchProps extends SwitchProps {
    label: string;
    handleToggle: (value: boolean) => void;
}

export const SystemSwitch: React.FC<SystemSwitchProps> = (props) => {
    const { label, checked, handleToggle } = props;

    const onChange = (_event: React.SyntheticEvent, isChecked: boolean) => {
        handleToggle(isChecked);
    }

    return (
        <FormControlLabel
            control={(
                <StyledSwitch
                    checked={checked}
                    onChange={onChange}
                />
            )}
            label={label}
        />
    );
};

interface ControlledSystemSwitchProps extends Omit<SystemSwitchProps, "checked" | "handleToggle"> {
    name: string;
}

export const ControlledSystemSwitch: React.FC<ControlledSystemSwitchProps> = (props) => {
    const { name, ...restOfProps } = props
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <SystemSwitch
                    {...field}
                    {...restOfProps}
                    checked={field.value}
                    handleToggle={(checked) => field.onChange(checked)}
                />
            )}
        />
    );
}